import {FC} from 'react';
import {AssignToContainer} from './AssignToContainer';
import {WorkersAndGroups} from './WorkersAndGroups';

const AssignTo: FC = () => {
  return (
    <AssignToContainer>
      <WorkersAndGroups />
    </AssignToContainer>
  );
};

export default AssignTo;
